import { isStudioThemeId, STUDIO_THEMES } from 'fym-shared/src/music24/studioThemes';
import { KIT_ASSET_WORKING_STATUSES, SerializedKitAsset } from '../../../../../redux/api/fymAPI.types';

/**
 * The current image assets of a song that still render (the head "Your first images", design c5).
 * Only a first revision counts: a later revision is not one of the first images (QA 2026-10-28,
 * imp-8), so the working banner shows it.
 */
export function countWorkingImages(assets: readonly SerializedKitAsset[]): number {
  return assets.filter(
    (asset) =>
      asset.supersededAt === null &&
      (asset.version ?? 1) <= 1 &&
      KIT_ASSET_WORKING_STATUSES.includes(asset.status) &&
      isStudioThemeId(asset.themeId) &&
      STUDIO_THEMES[asset.themeId].format === 'image'
  ).length;
}
